import gql from 'graphql-tag';

export default ({ id }) => {
  const exportExchangeRate = `exportExchangeRate(input: { id: "${id}" })`;
  return gql`
    query {
      ${exportExchangeRate} {
        id
        name
        userId
        effectiveDate
        type
        exchangeRateList {
          index
          sourceCurrency
          targetCurrency
          type
          exchangeRate
        }
      }
    }
  `;
};
